/*
 * Copyright (c) 2021. Manchester Economic Forecasting Limited <http://mef-uk.com>
 */

import React, { lazy, Suspense } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';

import './styles.css';
import Header from './components/Header';
import Auth0ProviderWithHistory from './auth/Auth0ProviderWithHistory';
import LoadingScreen from './components/LoadingScreen';

const Info = lazy(() => import('./Tabs/InfoStart'));
const MacroEcon = lazy(() => import('./Tabs/MacroEconomics'));
const ESG = lazy(() => import('./Tabs/ESG'));
const Emissions = lazy(() => import('./Tabs/Emissions'));
const EmissionsBreakdown = lazy(() => import('./Tabs/EmissionsBreakdown/EmissionsBreakdown'));
const EmissionsBreakdownFirms = lazy(() => import('./Tabs/GHGfirms/EmissionsBreakdownFirms'));
const WorldTrade = lazy(() => import('./Tabs/WorldTrade'));
const TopicLinks = lazy(() => import('./Tabs/TopicLinks'));
const MCQs = lazy(() => import('./Tabs/MCQs'));
const Glossary = lazy(() => import('./Tabs/Glossary'));
const NewMonteCarlo = lazy(() => import('./Tabs/NewMonteCarlo'));
const MonteCarloGHG = lazy(() => import('./Tabs/MonteCarloGHG'));
const Sunburst = lazy(() => import('./Tabs/Sunburst'));
const Portfolio = lazy(() => import('./Tabs/Portfolio'));

const App = (): JSX.Element => (
	<div className="App">
		<BrowserRouter>
			<Auth0ProviderWithHistory>
				<Header />
				<Suspense fallback={<LoadingScreen />}>
					<Switch>
						<Route exact path="/macro" component={MacroEcon} />
						<Route exact path="/esg" component={ESG} />
						<Route exact path="/emissions" component={Emissions} />
						<Route exact path="/trade-links" component={WorldTrade} />
						<Route exact path="/topic-links" component={TopicLinks} />
						<Route exact path="/monte-carlo" component={NewMonteCarlo} />
						<Route exact path="/monte-carlo-ghg" component={MonteCarloGHG} />
						<Route exact path="/mcqs" component={MCQs} />
						<Route exact path="/emissions-breakdown" component={EmissionsBreakdown} />
						<Route exact path="/ghg-firms" component={EmissionsBreakdownFirms} />
						<Route exact path="/glossary" component={Glossary} />
						<Route exact path="/" component={Info} />
						<Route exact path="/sunburst" component={Sunburst} />
						<Route exact path="/portfolio" component={Portfolio} />
					</Switch>
				</Suspense>
			</Auth0ProviderWithHistory>
		</BrowserRouter>
	</div>
);

export default App;
